export const NVD_PASSWORDLESS_LOGIN_EXPERIMENT = 'nvd_passwordless_login';

export const SUBSCRIPTION_PLAN_PRICING_AVAILABILITY = 'subscription_plan_pricing_availability';

export const BUNDLE_COUPON = 'BUNDLE_COUPON';
